const ROUTE_TYPE_MAP = {
    HR: './staff',
    FIELD_REPORT: './field-report-home',
    FRUIT_SALES: './blueberry-sales-home',
    BLUEBERRY_REPORT: './blueberry-report-home',
    PLANE_TICKET: './ticket-plane',
    DRAINAGE_REPORT: './workbench-drainage-report',
    WAREHOUSE_HAINAN: './warehouse-home',
    PICK_MONITOR: './blueberry-monitor-list',
    MC_WEIGH: './blueberry-weigh-list',
    PICK_REPORT: './pickReport-index',
    PACK_REPORT: './packReport-index',
    HANDOVER_REPORT: './handoverReport-index',
    SALE_REPORT: './saleReport-index',
    DEVICE_MAINTENANCE: './maintenance-index',
    MAINTENANCE_DEVICE_INFO: './maintenance-deviceInfo',
    FRUITINFO_VIEW: './fruitInfo-view',
    PLANT: './plant',
    WAREHOUSE_PRODUCTFRUIT_STORAGE: './warehouse-productFruit-storage',
    FARM_MANAGEMENT: './farmmanage-index',
    SALE_LINK_TIME: './saleOrderLinkTime-index',
    PDC: './pdc-statistics',
    HN_SALE_REPORT: './warehouse-reports',
    UNITE_WHOLESALE: './unionsale-home',
    PICK_QUALITY_REPORT: './pickQuality-report',
    VEHICLE_REPORT: './vehicle-machiningCenter-report',
    CLUB_WHOLESALE: './clubsale-home',
    LM_LEVEL_ADJUST_APPLY: './blueBerryLevel-list',
    BLUEBERRIES_SCRAPPED_MANAGER: './blueberry-scrapped',
    BLUEBERRIES_LOSS_MANAGER: './blueberry-loss',
    MSG_CENTER_REMINDER: './workbench-levelWraing-index',
    LPCK_APPLY_APPROVAL: './blueberry-application-list',
    PLANT_GROWTH: './skill-home',
    PLANT_ASSISTANT: './plant-assistant',
    FULL_LINK_QUALITY_MANAGEMENT: './full-link-quality-management',
    PICK_ORDER_TYPE: './workbench-palletMonitor',
    PICK_REWORK: './blueberry-reWork',
    COUPON: './coupon',
    DISCLOSURE_BOARD: './thirdLevel-disclosureBoard',
    CKCY_APPROVE: './blueberry-differential-approval',
    HONEYBEE_ADD: './honeybee-life-list',
    PEST_DISEASE_CONTROL: './pest-records',
    MATERIAL_REQUISITION: './workbench-otherMaterialRequisition-list',
    PLANT_PROTECT: './skil-fill-flowerAdd-new',
    LOGISTICS_BIDDING: './unionsale-priceCompareTask-list',
    RETURN_PROCESS: './return-process',
    BI_PERMISSION: './bi-home'
};

const QUERY_PARAMS = {
    MAINTENANCE_DEVICE_INFO: { queryKey: 'deviceCode' },
    SALE_LINK_TIME: { queryKey: 'saleOrderNo', querySource: 'deviceCode' }
};

function getRouteByType(type, extraQuery) {
    const path = ROUTE_TYPE_MAP[type];
    if (!path) return null;

    const route = { path };
    const queryConfig = QUERY_PARAMS[type];
    if (queryConfig && extraQuery) {
        const queryValue = extraQuery[queryConfig.querySource || queryConfig.queryKey];
        if (queryValue) {
            route.query = { [queryConfig.queryKey]: queryValue };
        }
    }
    return route;
}

export { ROUTE_TYPE_MAP, QUERY_PARAMS, getRouteByType };
